import type { FormValues } from '../SamplesOrders.types'

export const removeItemFromValues = (values: FormValues, id: string): FormValues => {
  const items = values.items.filter((item) => item.variantId !== id)

  return { items }
}
